export const apiDefaultParams = {
  apiVersion: "1",
  authorization: undefined,
  authVersion: "V0.0.1",
  companyView: undefined,
  pageSize: 99999,
};
